import React from 'react';
import { Field, ErrorMessage } from 'formik';
import { Typography, Button } from '@material-tailwind/react';
import { MagnifyingGlassCircleIcon } from '@heroicons/react/24/outline';
import { seleccionarTextoInput } from '../../Helpers/utilidades-globales';

export const TabDatosContacto = ({
    values,
    esVisualizacion,
    handleChange,
    provincias,
    setBuscarProvincias,
    toggle
}) => {
    return (
        <div className="bg-white p-5 rounded-md">
            <div className="flex f-col">
                <Typography variant="small" color="blue-gray" className="mb-1 font-medium">
                    Dirección
                </Typography>
                <Field
                    id="abm-direccion"
                    type="text"
                    autoComplete="off"
                    maxLength="100"
                    name="direccion"
                    disabled={esVisualizacion}
                    onFocus={() => seleccionarTextoInput("abm-direccion")}
                    onClick={() => seleccionarTextoInput("abm-direccion")}
                    className={`input-ui-data ${values.direccion ? 'input-cvalor' : 'input-vacio'}`}
                />
                <div className="error_formulario"><ErrorMessage name="direccion" /></div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
                <div className="flex f-col">
                    <Typography variant="small" color="blue-gray" className="mb-1 font-medium">
                        Barrio
                    </Typography>
                    <Field
                        id="abm-barrio"
                        type="text"
                        autoComplete="off"
                        maxLength="100"
                        name="barrio"
                        disabled={esVisualizacion}
                        onFocus={() => seleccionarTextoInput("abm-barrio")}
                        onClick={() => seleccionarTextoInput("abm-barrio")}
                        className={`input-ui-data ${values.barrio ? 'input-cvalor' : 'input-vacio'}`}
                    />
                    <div className="error_formulario"><ErrorMessage name="barrio" /></div>
                </div>

                <div className="flex f-col">
                    <Typography variant="small" color="blue-gray" className="mb-1 font-medium">
                        Localidad
                    </Typography>
                    <Field
                        id="abm-localidad"
                        type="text"
                        autoComplete="off"
                        maxLength="500"
                        name="localidad"
                        disabled={esVisualizacion}
                        onFocus={() => seleccionarTextoInput("abm-localidad")}
                        onClick={() => seleccionarTextoInput("abm-localidad")}
                        className={`input-ui-data ${values.localidad ? 'input-cvalor' : 'input-vacio'}`}
                    />
                    <div className="error_formulario"><ErrorMessage name="localidad" /></div>
                </div>

                <div className="flex f-col el-abm-sel-pos">
                    <div className="flex space-x-2 f-row justify-between items-center mb-1">
                        <Typography variant="small" color="blue-gray" className="font-medium">
                            Provincia
                        </Typography>
                        {!esVisualizacion && <Button type="button"
                            variant='text'
                            className="flex cursor-pointer p-0 m-0"
                            onClick={() => { setBuscarProvincias(true); toggle() }}>
                            <MagnifyingGlassCircleIcon width={16} className='mr-1' />
                            <span className='text-xs'>Buscar</span>
                        </Button>}
                    </div>
                    <select onChange={handleChange} value={values.id_provincia}
                        name="id_provincia"
                        disabled={esVisualizacion}
                        className="select-bg-ui w-full" id="abm-curso-profesor">
                        <option disabled value="-1">Seleccionar</option>
                        {provincias.map(item =>
                            <option key={`abmcurso-permiso${item.id_provincia}`} value={item.id_provincia}>{item.nombre}</option>
                        )}
                    </select>
                    <div className="error_formulario"><ErrorMessage name="id_provincia" /></div>
                </div>

                <div className="flex flex-col el-abm-sel-pos">
                    <Typography variant="small" color="blue-gray" className="mb-1 font-medium">
                        Código Postal
                    </Typography>
                    <Field
                        id="abm-cod_postal"
                        type="text"
                        autoComplete="off"
                        maxLength="10"
                        name="cod_postal"
                        disabled={esVisualizacion}
                        onFocus={() => seleccionarTextoInput("abm-cod_postal")}
                        onClick={() => seleccionarTextoInput("abm-cod_postal")}
                        className={`input-ui-data ${values.cod_postal ? 'input-cvalor' : 'input-vacio'}`}
                    />
                    <div className="error_formulario"><ErrorMessage name="cod_postal" /></div>
                </div>

                <div className="flex f-col mt-2">
                    <Typography variant="small" color="blue-gray" className="mb-1 font-medium">
                        Teléfono
                    </Typography>
                    <Field
                        id="abm-alumno-telefono"
                        type="text"
                        autoComplete="off"
                        disabled={esVisualizacion}
                        onFocus={() => seleccionarTextoInput("abm-alumno-telefono")}
                        onClick={() => seleccionarTextoInput("abm-alumno-telefono")}
                        maxLength="50"
                        name="telefono"
                        className={`input-ui-data ${values.telefono ? 'input-cvalor' : 'input-vacio'}`}
                    />
                    <div className="error_formulario"><ErrorMessage name="telefono" /></div>
                </div>

                <div className="flex f-col mt-2">
                    <Typography variant="small" color="blue-gray" className="mb-1 font-medium">
                        Fax
                    </Typography>
                    <Field
                        id="abm-fax"
                        type="text"
                        autoComplete="off"
                        disabled={esVisualizacion}
                        onFocus={() => seleccionarTextoInput("abm-fax")}
                        onClick={() => seleccionarTextoInput("abm-fax")}
                        maxLength="500"
                        name="fax"
                        className={`input-ui-data ${values.fax ? 'input-cvalor' : 'input-vacio'}`}
                    />
                    <div className="error_formulario"><ErrorMessage name="fax" /></div>
                </div>
            </div>

            <div className="flex f-col mt-4">
                <Typography variant="small" color="blue-gray" className="mb-1 font-medium">
                    Observaciones
                </Typography>
                <Field
                    as="textarea"
                    id="abm-observaciones"
                    name="observaciones"
                    rows="4"
                    disabled={esVisualizacion}
                    placeholder="Ingrese detalles o notas adicionales..."
                    className={`input-ui-data w-full p-2 border rounded-md ${values.observaciones ? 'input-cvalor' : 'input-vacio'}`}
                    style={{ minHeight: '100px', resize: 'vertical' }}
                />
                <div className="flex justify-end">
                    <span className="text-xxsmall color-gray">
                        {values.observaciones?.length || 0} / 500
                    </span>
                </div>
                <div className="error_formulario">
                    <ErrorMessage name="observaciones" />
                </div>
            </div>
        </div>
    );
};
